module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "marker"
  }, [_c('ul', {
    staticClass: "rigth"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "side-nav",
      rawName: "v-side-nav:demo",
      value: (_vm.nav),
      expression: "nav",
      arg: "demo"
    }],
    staticClass: "sizeA stroke",
    attrs: {
      "href": "#!"
    }
  }, [_c('i', {
    staticClass: "material-icons dp48 fa-3x"
  }, [_vm._v("apps")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Menu")])])])])]), _vm._v(" "), _c('div', [_c('v-side-nav', {
    attrs: {
      "id": "demo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v("Cliente")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cliente),
      expression: "cliente"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cliente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cliente = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.mostrarClientes) ? _c('transition-group', {
    staticClass: "Results",
    attrs: {
      "name": "fade",
      "tag": "ul"
    }
  }, _vm._l((_vm.clientes), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.seleccionarCliente(item)
        }
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(item.nombre))]), _c('br')])])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('p', [_vm._v("Fecha Inicio")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Fecha Fin")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Mensajeros")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "select",
      "id": "select",
      "select-text": "Seleccionar Mensajero",
      "preselect-first": true,
      "items": _vm.messengers
    },
    model: {
      value: (_vm.messengerSelected),
      callback: function($$v) {
        _vm.messengerSelected = $$v
      },
      expression: "messengerSelected"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Entregas")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minEntries),
      expression: "minEntries"
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.minEntries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minEntries = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "for": "regreso"
    }
  }, [_vm._v("Ida y Regreso")]), _vm._v(" "), _c('div', {
    staticClass: "switch"
  }, [_c('label', [_vm._v("\n            No\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regreso),
      expression: "regreso"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.regreso) ? _vm._i(_vm.regreso, null) > -1 : (_vm.regreso)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.regreso,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.regreso = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.regreso = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.regreso = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lever"
  }), _vm._v("\n            Si\n          ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-info",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.generarReporte
    }
  }, [_vm._v("Generar")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.mostrarLoader) ? _c('div', {
    staticClass: "center-align"
  }, [_c('img', {
    staticClass: "responsive-img",
    attrs: {
      "src": require("../assets/loader.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mostrarTabla) ? _c('div', {
    staticClass: "row"
  }, [_c('p', [_c('strong', [_vm._v("Total Servicios: ")]), _vm._v(_vm._s(_vm.muestras.length))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Eficiencia (media): ")]), _vm._v(_vm._s(parseFloat(_vm.grandTotal).toFixed(2)))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Desviación Estandar: ")]), _vm._v(_vm._s(parseFloat(_vm.devEst).toFixed(2)))]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "center-align"
  }, [_vm._v("Optimo")]), _vm._v(" "), _c('th', {
    staticClass: "center-align"
  }, [_vm._v("Normal")]), _vm._v(" "), _c('th', {
    staticClass: "center-align"
  }, [_vm._v("Deficiente")]), _vm._v(" "), _c('th', {
    staticClass: "center-align"
  }, [_vm._v("Ineficiente")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.optimo)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.normal)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.ineficiente)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.optimoEntrega)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.normalEntrega)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.ineficienteEntrega)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("-")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s3"
  }, _vm._l((_vm.serviciosOptimos), function(item, index) {
    return (index <= 15) ? _c('a', {
      key: item.id,
      attrs: {
        "href": ("https://my.guepardos.co/tracking/" + (item.id) + "?nav=false"),
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(_vm.lastFive(item.id)) + " "), _c('br')]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col s3"
  }, _vm._l((_vm.serviciosNormales), function(item, index) {
    return (index <= 15) ? _c('a', {
      key: item.id,
      attrs: {
        "href": ("https://my.guepardos.co/tracking/" + (item.id) + "?nav=false"),
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(_vm.lastFive(item.id)) + " "), _c('br')]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col s3"
  }, _vm._l((_vm.serviciosIneficientes), function(item, index) {
    return (index <= 15) ? _c('a', {
      key: item.id,
      attrs: {
        "href": ("https://my.guepardos.co/tracking/" + (item.id) + "?nav=false"),
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(_vm.lastFive(item.id)) + " "), _c('br')]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col s3"
  }, _vm._l((_vm.serviciosDeficientes), function(item, index) {
    return (index <= 15) ? _c('a', {
      key: item.id,
      attrs: {
        "href": ("https://my.guepardos.co/tracking/" + (item.id) + "?nav=false"),
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(_vm.lastFive(item.id)) + " "), _c('br')]) : _vm._e()
  }), 0)])]) : _vm._e()], 1)]), _vm._v(" "), _c('gmap-map', {
    ref: "mapEficiencia",
    staticClass: "sinNav",
    attrs: {
      "center": _vm.center,
      "options": {
        streetViewControl: false
      },
      "zoom": _vm.zoom
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  })], 2)], 1), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "foo",
      "position": "bottom left"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3405bcab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Eficiencia.vue
// module id = 339
// module chunks = 1